import { useState } from 'react'

// Shows /screenshots/<name>.webp. Desktop screens get a browser frame; phone screenshots
// already include their device frame. A missing file falls back to a labelled placeholder.
export default function Screenshot({ name, label, phone = false, url, children }) {
  const [missing, setMissing] = useState(false)
  const src = `${import.meta.env.BASE_URL}screenshots/${name}.webp`

  if (phone) {
    return missing ? (
      <div className="phone-missing"><span className="ph-badge">Screenshot: {name}.webp</span></div>
    ) : (
      <img className="phone-shot" src={src} width="539" height="1100" alt={label} onError={() => setMissing(true)} />
    )
  }

  return (
    <div className="browser">
      <div className="browser-bar">
        <span /><span /><span />
        <div className="browser-url">{url || `app.vnumngr.com/${name}`}</div>
      </div>
      <div className="browser-body">
        {missing ? <span className="ph-badge">Screenshot: {name}.webp</span> : <img src={src} srcSet={`${src.replace(/\.webp$/, '-800.webp')} 800w, ${src} 1600w`} sizes="(max-width: 760px) 100vw, 720px" alt={label} loading="lazy" onError={() => setMissing(true)} />}
        {!missing && children}
      </div>
    </div>
  )
}
